import axios from "axios";
import { nuclearn_api_url } from "src/App";

/**
 * Record the user's Clear all on the server, so the Redis-held history is
 * not backfilled to their next subscriber (a reload, a new tab, another
 * device). Best-effort: the bell is already empty in this tab, and a backend
 * without the route answers 404, so a failure is logged and nothing else.
 */
export async function clearNotificationHistory(): Promise<void> {
  try {
    await axios.post(`${nuclearn_api_url}/notifications/user/clear`);
  } catch (err) {
    console.warn("Could not record the notification clear on the server", err);
  }
}

/**
 * Record on the server that the user has read everything in the bell, so
 * the next backfill (reload, new tab, another device) files it as read
 * history; anything published later comes back unread. `lastEventId` is
 * the stream position this tab has actually received (null = the server's
 * newest), so an alert that landed after the read is not marked with it.
 * Best-effort, like the clear: the tab's own read state stands either way.
 */
export async function markNotificationsSeen(
  lastEventId: string | null,
): Promise<void> {
  try {
    await axios.post(`${nuclearn_api_url}/notifications/user/seen`, {
      last_event_id: lastEventId,
    });
  } catch (err) {
    console.warn("Could not record notifications as seen on the server", err);
  }
}
